import React, { useCallback } from "react";
import { IconButton } from "@toddle-edu/ds-web";
import { SendFilled, SquareFilled } from "@toddle-edu/ds-icons";

const AIPanelSendButton = props => {
  const { onSend, onStop, testId, showStop, isSending, isDisabled } = props;

  const handleClick = useCallback(() => {
    if (showStop || isSending) {
      onStop?.();
    } else {
      onSend?.();
    }
  }, [showStop, isSending, onSend, onStop]);

  if (showStop || isSending) {
    return (
      <IconButton
        type="plain"
        size="medium"
        dsVersion="2.0"
        variant="neutral"
        disabled={isDisabled}
        onClick={handleClick}
        icon={<SquareFilled />}
        testId={`${testId}-stopButton`}
      />
    );
  }

  return (
    <IconButton
      type="fill"
      size="medium"
      dsVersion="2.0"
      disabled={isDisabled}
      onClick={handleClick}
      variant="progressive"
      testId={`${testId}-sendButton`}
      icon={<SendFilled variant="on" />}
    />
  );
};

export default AIPanelSendButton;
